import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15ZM12 6C11.4872 6 11.0645 6.38604 11.0067 6.88338L11 7V13C11 13.5523 11.4477 14 12 14C12.5128 14 12.9355 13.614 12.9933 13.1166L13 13V7C13 6.44772 12.5523 6 12 6Z" })
});
export default SvgWarningFill;
